<template>
  <div id="new-employee">
<PageTitle  v-if="id==''" title='Nieuwe medewerker'></PageTitle>    
    <PageTitle v-if="id!=''"
      title="Medewerker bewerken"
      description="Als er een avatar is gekoppeld is deze hieronder zichtbaar. Wanneer je een nieuwe afbeelding kiest wordt de oude verwijderd."
    ></PageTitle>

      <div class="form-group float-right">
      <button @click="cancel" class="btn btn-light mr-2">Annuleren</button>
      <button @click="saveUser" class="btn btn-success">Opslaan</button>
      </div>
    <Storage path="avatars/" :initialPic="initialPic" v-on:setUrl='setUrl' v-on:setFilename="setFilename" imageOnly></Storage>

    <form @submit.prevent="">
      <div class="form-group">
      <div class="row">
        <div class="col">
          <input type="text" class="form-control" placeholder="voornaam" v-model="firstname" />
        </div>
        <div class="col">
          <input type="text" class="form-control" placeholder="achternaam" v-model="lastname" />
        </div>
      </div>
      </div>
      <div class="form-group">
      <div class="row">
        
        <div class="col">
          <input type="text" class="form-control" placeholder="emailadres" v-model="email" />
        </div>
        <div class="col">
          <input
            type="text"
            class="form-control"
            placeholder="telefoonnummer"
            v-model="phonenumber"
          />
        </div>
      </div>
      </div>
      
      <Selectoptions v-on:setOptions="setOptions" :checkedEstablishments="checkedEstablishments" :checkedPositions="checkedPositions"></Selectoptions>
    </form>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PageTitle from '@/components/PageTitle.vue';
import Storage from "@/components/Storage.vue";
import Selectoptions from "@/components/Selectoptions.vue";
var firestorage = fb.firestorage;

export default {
  name: "new-employee",
  components: {
    PageTitle,
    Storage,
    Selectoptions
  },
  data() {
    return {
      checkedEstablishments: [],
      checkedPositions: [],
      downloadURL: '',
      fileName: '',
      firstname: null,
      lastname: null,
      email: null,
      phonenumber: null,
      initialPic: '',
      id: "",
    };
  },
  methods: {
    setOptions(data){
      this.checkedPositions = data.checkedPositions
      this.checkedEstablishments = data.checkedEstablishments
    },
    setUrl(url){
        this.downloadURL = url
    },
    setFilename(fn){
        this.fileName = fn
    },
    saveUser () { 
      
      var now = new Date();
      console.log("ID: " + this.id)


      if (this.id == ""){

        fb.usersCollection.add({          
          date_created: now.toISOString(),
            created_by: this.$cookies.get("user"),          
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email.toLowerCase(),
            phonenumber: this.phonenumber,
            company: this.$cookies.get("company"),
            bio: 'nog geen informatie',
          avatar: { url: this.downloadURL, filename: this.fileName},
          establishments:
            this.checkedEstablishments.length > 0
              ? this.checkedEstablishments
              : null,
          positions:
            this.checkedPositions.length > 0
              ? this.checkedPositions
              : null
        }).then(docRef => {
            console.log(docRef.id)
            this.$router.push("/employees")
        }).catch(error => console.log(error))

      } else {
        var docId = this.id

        fb.usersCollection.doc(docId).update({          
          date_updated: now.toISOString(),
            updated_by: this.$cookies.get("user"),          
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            phonenumber: this.phonenumber,
         avatar: { url: this.downloadURL, filename: this.fileName},
          establishments:
            this.checkedEstablishments.length > 0
              ? this.checkedEstablishments
              : null,
          positions:
            this.checkedPositions.length > 0
              ? this.checkedPositions
              : null
        }).then(() => {
            this.$router.push("/employees")
        }).catch(error => console.log(error))
      }
    },
    cancel() {
      // afbeelding? weggooien dan
      if (this.downloadURL != "" && this.id == "new") {
        firestorage
          .ref("avatars/" + this.$cookies.get("company") + "/" + this.fileName)
          .delete()
          .then(() => {
            this.$router.go(-1);
          })
          .catch(error => {
            console.error(`file delete error occured: ${error}`);
          });
      } else {
          this.$router.go(-1);
      }
    }
  },
 
  beforeRouteEnter(to, from, next) {
    if (to.params.id && to.params.id != "new") {
      fb.usersCollection
        .doc(to.params.id)
        .get()
        .then(doc => {
          console.log(doc.data());
          next(vm => {
            vm.id = doc.id;
            vm.firstname = doc.data().firstname
            vm.lastname = doc.data().lastname
            vm.email = doc.data().email
            vm.phonenumber = doc.data().phonenumber
            if (doc.data().establishments != null ) vm.checkedEstablishments = doc.data().establishments;
            if (doc.data().positions != null ) vm.checkedPositions = doc.data().positions;
            vm.downloadURL = doc.data().avatar.url ?? '';
            vm.initialPic = doc.data().avatar.url ?? '';
            vm.fileName = doc.data().avatar.filename ?? ""; // if you feel this should not be done here, then also make sure that in the save method the avatar is not overwritten by an empty value
          });
        });
    } else {
      next();
    }
  }
};
</script>